<template>
  <div
    v-if="value != '' || erreur != ''"
    style="top: 20px; right: 10%; width: 80%; position: fixed; z-index: 1000; margin: 0 auto;"
  >
    <v-alert
      v-model="afficher"
      class="text-center mb-0"
      type="error"
      dismissible
      color="#CB381F"
    >
      <span v-if="value != ''" v-html="value"></span>
      <span v-else-if="erreur != ''" v-html="$t(erreur)"></span>
      <span
        id="messageSoutien"
        style="color:darkgray"
      >
        {{ appStore.messageSoutien }}
      </span>
    </v-alert>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';

export default {
  props: {
    value:
    {
      required: true,
    },
  },
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  data() {
    return {
      afficher: false,
    };
  },
  mounted() {
    if ((this.value != null && this.value !== '') || (this.erreur != null && this.erreur !== '')) {
      this.afficher = true;
    }
  },
  computed: {
    erreur() {
      return this.appStore.erreur;
    },
  },
  watch:
  {
    value() {
      // Par défaut, value est vide, si le parent signale une erreur, on affiche l'alerte
      if (this.value !== '') this.afficher = true;
    },
    afficher() {
      // Par défaut, afficher est faux, si clique sur dismiss et redevient faux, on émet l'erreur vide.
      if (this.afficher === false) {
        this.$emit('input', '');
      }
    },
    erreur() {
      // Si l'erreur est une des suivantes, on ne l'affiche pas car afficher en bas de page dans le panier
      const erreursNePasAfficher = [
        'erreurs.CleCoursDejaAchete',
        'erreurs.CleCoursNonEligibleOrganisme',
        'erreurs.CleInscriptionFerme',
      ];
      if (erreursNePasAfficher.includes(this.appStore.erreur)) {
        this.afficher = false;
      } else if (this.erreur != null && this.erreur !== '') {
        this.afficher = true;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.error {
  background-color: #CB381F;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}

::v-deep .blanc  {
  color: white;
}
</style>
